import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {classMap} from 'lit/directives/class-map.js';

import {connect} from 'pwa-helpers';
import store from '../../../store';


@customElement('cover-table')
export class CoverTable extends connect(store)(LitElement) {

	static styles = css`
		.coverTableItem {
			display: flex;
			justify-content: space-between;
			width: 100%;
			padding-bottom: var(--specsheet-medium-gap);
		}
		.coverTableItem.compact {
			padding-bottom: 0;
		}

		.title {
			width: 35%;
			font: var(--font-summary-paragraph);
			padding-top: var(--sections-gap);
			color: #939393;
		}

		.content {
			width: 65%;
		}

		@media print {
			.coverTableItem {
				display: flex;
				justify-content: space-between;
				width: 100%;
				padding-top: var(--specsheet-small-gap);
			}


			.title {
				font: var(--font-specsheet-print-light);
				color: #939393;
				padding-top: var(--sections-gap);
			}
		}
	`;

	@property({type: String})
	key = '';

	@property({type: Boolean})
	compact = false;

	@property({type: String})
	title = false;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.lang = state.status.lang;
	}

	render() {
		return html`
			<div class="coverTableItem ${classMap({compact: this.compact})}">
				<div class="title">${this.title}</div>
				<div class="content">
					<slot></slot>
				</div>
			</div>
		`;
	}
}
